module.exports = __webpack_public_path__ + "static/img/xdt_lan.7cccc6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xdt_lan.png
// module id = c0LU
// module chunks = 0